import React, { memo, Suspense } from 'react'

import Projects from '@/components/Projects/Projects'
import Navigation from '@/components/Navigation/Navigation'

interface Props {}

const ProjectsPage: React.FC<Props> = memo(() => {
  return <Projects />
})
ProjectsPage.displayName = 'Projects'

export default ProjectsPage
